class Elementor_Speakers{
    static instance;

    static getInstance() {
        if (!Elementor_Speakers.instance) {
            Elementor_Speakers.instance = new Elementor_Speakers();
        }
        return Elementor_Speakers.instance;
    }

    constructor(){
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init(){
        elementorFrontend.hooks.addAction( 'frontend/element_ready/opal-speakers.default', ( $scope ) => {
            let $carousel = $scope.find('.owl-carousel');
            if($carousel.length > 0){
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
            }
        } );
    }
}


Elementor_Speakers.getInstance();